// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Common, Common as This, System } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Common-FancyLayout',
    templateUrl: './FancyLayout.html',
    styleUrls: ['./FancyLayout.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FancyLayout extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Common.FancyLayout';
    $isDialog = false;
    $Modules = $Modules;
    Common = Common;
    System = System;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    readonly screen =
        ((component: typeof this) => {
            return {

            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }

        this.zone.runOutsideAngular(() => {

            const scrollElements = this.elementRef.nativeElement.querySelectorAll("#main-content")
            scrollElements.forEach(scrollElement => {
                this.onDestroyFns.push(this.renderer.listen(scrollElement, 'scroll', event => {
                    const { scrollTop } = scrollElement
                    if (scrollTop <= 0 || scrollTop > 100) {
                        document.body.classList.toggle('scrolled', scrollTop > 100)
                    }
                }))
            })

        })
    }

    async ngAfterViewInit(): Promise<void> {

        const scrollElements = this.elementRef.nativeElement.querySelectorAll("#main-content")
        scrollElements.forEach(scrollElement => {
            this.onDestroyFns.push(this.renderer.listen(scrollElement, 'scroll', event => {
                const { scrollTop } = scrollElement
                if (scrollTop <= 0 || scrollTop > 100) {
                    document.body.classList.toggle('scrolled', scrollTop > 100)
                }
            }))
        })

    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            this.$isVariablesInitialized.set(true)
        })

        this.$isFullyInitialized.set(true)

    }
}
